import React from 'react'
import ContactImg from '../img/s1.jpg'
import '../css/Contact.css'

const Contact = () => {
    return (
        <div className="contactContainer" id="contact">
            <div className="contactLeftSection">
                <img src={ContactImg} alt="my_image" className="my_image"/>
            </div>            
            <div className="contactRightSection">
                <h1 className="contactHeader">Contact Me</h1>
                <form action="/">
                    <input type="text" className="formControl" placeholder="Enter Your Name*" required />
                    <input type="text" className="formControl" placeholder="Enter Your Email*" required />
                    <textarea name="contactTextArea" className="contactTextArea" id="contactTextArea" cols="133" rows="20" placeholder="Enter your thuoghts*" required />
                    <input type="submit" className="submitBtn" value="Submit"/>
                </form>
            </div>            
        </div>
    )
}

export default Contact
